import { type RouteLocationNormalized } from 'vue-router';

export function isFeatureEnabled(key: SupportedFeatures, route: RouteLocationNormalized): boolean {
  const featuresFromRoute = getFeaturesFromRoute(route);

  return featuresFromRoute.includes(key);
}

function getFeaturesFromRoute(route: RouteLocationNormalized): string[] {
  const features = (route?.query?.feature || '') as string;

  return features.split(',').map((feature) => feature.trim());
}

export enum SupportedFeatures {
  DEACTIVATE_REASON_MDOAL = 'useDeactivateReasonModal',
  PERFORMANCE_SCORE_SORTING = 'performanceScoreSorting',
  AI_DIAGNOSIS = 'aiDiagnosis',
  EXPERIMENTAL_TOPLISTING_PRICES = 'experimentalToplistingPrices',
  SHOW_INSIGHTS_HUB = 'showInsightsHub',
}
